"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDefaultXAxis = void 0;
var Colors_1 = require("@CommonFrontend/Styles/Colors");
var react_1 = __importDefault(require("react"));
var recharts_1 = require("recharts");
var BarTickWithSelected_1 = require("../Customise/BarTickWithSelected");
var TICK_GAP = 16;
function GetDefaultXAxis(_a) {
    var data = _a.data, isMobile = _a.isMobile;
    var tickGap = isMobile ? TICK_GAP * 0.5 : TICK_GAP;
    return (react_1.default.createElement(recharts_1.XAxis, { tickLine: false, dataKey: "xAxisName", height: tickGap * 4, axisLine: { stroke: Colors_1.ColorPalette.Slate, opacity: 0.5 }, tick: function (props) { return react_1.default.createElement(BarTickWithSelected_1.BarTickWithSelected, { tickProps: props, data: data, tickGap: tickGap }); } }));
}
exports.GetDefaultXAxis = GetDefaultXAxis;
